import { ElementRendererProps } from "./paragraph";

export const BulletedList = ({
  attributes,
  children,
}: ElementRendererProps<"bulleted-list">) => (
  <ul
    className="list-none block m-0 pl-4 my-1 [&>li]:relative [&>li]:pl-[1.7rem] [&>li]:before:absolute [&>li]:before:left-[0.1rem] [&>li]:before:block [&>li]:before:w-[4rem] [&>li]:before:text-left [&>li]:before:content-['•']"
    {...attributes}
  >
    {children}
  </ul>
);

export const NumberedList = ({
  attributes,
  children,
}: ElementRendererProps<"numbered-list">) => (
  <ol className="list-decimal list-inside block m-0 pl-4 my-1" {...attributes}>
    {children}
  </ol>
);

export const ListItem = ({
  attributes,
  children,
}: ElementRendererProps<"list-item">) => (
  <li className="m-0" {...attributes}>
    {children}
  </li>
);
